import { isDate, isNotNullUndefinedOrEmptyString } from '@/features/shared/tools'
import { isAdherentOuMandatGestion } from './tools'
import type { SourceNirDTO } from '@/features/api/extranet/dto/Demande/shared'

/* Communes */
export const preNotNullOrEmpty = isNotNullUndefinedOrEmptyString
export const preDateValide = (value: any) => isDate(value)
export const preEquals =
  (...args: any[]) =>
    (value: any) =>
      args.includes(value)
export const preNotEquals =
  (...args: any[]) =>
    (value: any) =>
      !args.includes(value)

export const preAdherentOuMandatGestion = isAdherentOuMandatGestion
export const preEstNirPortail = (_value: any, parent: SourceNirDTO) =>
  parent?.source === 'Portail'
